module.exports = __webpack_public_path__ + "img/logo.01ea4423.png";